import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
const GoablTempalateFrontDesk = React.lazy(() => { return import('../../components/GoablTempalateFrontDesk'); });

const { Cell } = ResponsiveGrid;

function getObj(){
   
  return {
    service:'communityRules',   
    name:"規範",
    display :true 
  }


}
const CommunityRulesFrontDesk = () => (
  // <ResponsiveGrid gap={20}>
  //   <Cell colSpan={12}>
  //     <PageHeader
  //       title="公告事項前台"
  //       // description="公告事項前台"
  //       breadcrumbs={[
  //         {
  //           name: '公告事項',
  //         },
  //         {
  //           name: '公告事項前台',
  //         },
  //       ]}
  //     />
  //   </Cell>

  //   <Cell colSpan={12}>
  //   <React.Suspense fallback={<div>Loading...</div>} >
  //     <AnnouncementFrontDeskList />
  //     </React.Suspense>
  //   </Cell>
  // </ResponsiveGrid>
  <React.Suspense fallback={<div>Loading...</div>} >
    <GoablTempalateFrontDesk data={getObj()}/>
  </React.Suspense>
);

export default CommunityRulesFrontDesk;
